import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuthenticationService } from './service/authentication.service';
import { MenuService } from './component/menu/menu.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(router, logger, authenticationService, menuService) {
        this.router = router;
        this.logger = logger;
        this.authenticationService = authenticationService;
        this.menuService = menuService;
        router.events.subscribe(function (event) {
            logger.debug('RouterEvent:', event);
            if (event instanceof NavigationStart) {
                menuService.checkMenuData(event.url);
            }
            if (event instanceof NavigationEnd) {
                window.scrollTo(0, 0);
            }
        });
    }
    AppComponent.prototype.logout = function () {
        var _this = this;
        this.authenticationService.logout().subscribe(function (data) {
            _this.router.navigate(['/login']);
        }, function (error) {
            _this.logger.debug(error);
        });
    };
    AppComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: '[my-app]',
                    template: "\n        <router-outlet></router-outlet>\n        <alertmodal></alertmodal>\n    ",
                    styles: ["h1 {\n  font-size: 1.2em;\n  color: #999;\n  margin-bottom: 0;\n}\n\nh2 {\n  font-size: 2em;\n  margin-top: 0;\n  padding-top: 0;\n}\n\nnav a {\n  padding: 5px 10px;\n  text-decoration: none;\n  margin-top: 10px;\n  display: inline-block;\n  background-color: #eee;\n  border-radius: 4px;\n}\n\nnav a:visited, a:link {\n  color: #607D8B;\n}\n\nnav a:hover {\n  color: #039be5;\n  background-color: #CFD8DC;\n}\n\nnav a.active {\n  color: #039be5;\n}\n"]
                }] }
    ];
    /** @nocollapse */
    AppComponent.ctorParameters = function () { return [
        { type: Router },
        { type: NGXLogger },
        { type: AuthenticationService },
        { type: MenuService }
    ]; };
    return AppComponent;
}());
export { AppComponent };
//# sourceMappingURL=app.component.js.map